import React, { useState } from 'react';
import styles from './Tabs.module.scss';

export const Tab = ({ label, children }) => {
  return (
    <div label={label} className={styles.tabContent}>
      {children}
    </div>
  );
};

export const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = useState(children[0].props.label);

  const handleClick = (e, newActiveTab) => {
    e.preventDefault();
    setActiveTab(newActiveTab);
  };

  return (
    <div className={styles.tabs}>
      <ul className={styles.tabList}>
        {children.map((child) => (
          <li
            key={child.props.label}
            className={activeTab === child.props.label ? styles.active : ''}
          >
            <a href="#" onClick={(e) => handleClick(e, child.props.label)}>
              {child.props.label}
            </a>
          </li>
        ))}
      </ul>
      <div className={styles.tabContent}>
        {children.map((child) => {
          if (child.props.label === activeTab) {
            return <div key={child.props.label}>{child.props.children}</div>;
          }
          return null;
        })}
      </div>
    </div>
  );
};